import allergy from '../svg/allergy.svg?raw';
import apple from '../svg/apple.svg?raw';
import arrowForward from '../svg/arrow-forward.svg?raw';
import arrowLeft from '../svg/arrow-left.svg?raw';
import arrowRight from '../svg/arrow-right.svg?raw';
import arrowUp from '../svg/arrow-up.svg?raw';
import back from '../svg/back.svg?raw';
import bookOpen from '../svg/book-open.svg?raw';
import calendar from '../svg/calendar.svg?raw';
import chat from '../svg/chat.svg?raw';
import checkCircle from '../svg/check-circle.svg?raw';
import check from '../svg/check.svg?raw';
import chevronDown from '../svg/chevron-down.svg?raw';
import chevronLeft from '../svg/chevron-left.svg?raw';
import chevronRight from '../svg/chevron-right.svg?raw';
import close from '../svg/close.svg?raw';
import condition from '../svg/condition.svg?raw';
import document from '../svg/document.svg?raw';
import dotsThreeHorizontal from '../svg/dots-three-horizontal.svg?raw';
import edit from '../svg/edit.svg?raw';
import exclamation from '../svg/exclamation.svg?raw';
import eyeOff from '../svg/eye-off.svg?raw';
import eye from '../svg/eye.svg?raw';
import faq from '../svg/faq.svg?raw';
import fileText from '../svg/file-text.svg?raw';
import filter from '../svg/filter.svg?raw';
import helpful from '../svg/helpful.svg?raw';
import info from '../svg/info.svg?raw';
import insurance from '../svg/insurance.svg?raw';
import language from '../svg/language.svg?raw';
import location from '../svg/location.svg?raw';
import logout from '../svg/logout.svg?raw';
import mail from '../svg/mail.svg?raw';
import medicalBuilding from '../svg/medical-building.svg?raw';
import medicalOutline from '../svg/medical-outline.svg?raw';
import medical from '../svg/medical.svg?raw';
import medication from '../svg/medication.svg?raw';
import navBenefits from '../svg/nav_benefits.svg?raw';
import navMore from '../svg/nav_more.svg?raw';
import pause from '../svg/pause.svg?raw';
import phone from '../svg/phone.svg?raw';
import play from '../svg/play.svg?raw';
import plus from '../svg/plus.svg?raw';
import preferences from '../svg/preferences.svg?raw';
import privacy from '../svg/privacy.svg?raw';
import provider from '../svg/provider.svg?raw';
import refresh from '../svg/refresh.svg?raw';
import reorderTwo from '../svg/reorder-two.svg?raw';
import search from '../svg/search.svg?raw';
import share from '../svg/share.svg?raw';
import thumbsDown from '../svg/thumbs-down.svg?raw';
import thumbsUp from '../svg/thumbs-up.svg?raw';
import time from '../svg/time.svg?raw';
import trash from '../svg/trash.svg?raw';
import userAdd from '../svg/user-add.svg?raw';
import vitals from '../svg/vitals.svg?raw';
import x from '../svg/x.svg?raw';
export const ICONS_BASE64 = {
  allergy: `data:image/svg+xml;utf8,${allergy}`,
  apple: `data:image/svg+xml;utf8,${apple}`,
  'arrow-forward': `data:image/svg+xml;utf8,${arrowForward}`,
  'arrow-left': `data:image/svg+xml;utf8,${arrowLeft}`,
  'arrow-right': `data:image/svg+xml;utf8,${arrowRight}`,
  'arrow-up': `data:image/svg+xml;utf8,${arrowUp}`,
  back: `data:image/svg+xml;utf8,${back}`,
  'book-open': `data:image/svg+xml;utf8,${bookOpen}`,
  calendar: `data:image/svg+xml;utf8,${calendar}`,
  chat: `data:image/svg+xml;utf8,${chat}`,
  'check-circle': `data:image/svg+xml;utf8,${checkCircle}`,
  check: `data:image/svg+xml;utf8,${check}`,
  'chevron-down': `data:image/svg+xml;utf8,${chevronDown}`,
  'chevron-left': `data:image/svg+xml;utf8,${chevronLeft}`,
  'chevron-right': `data:image/svg+xml;utf8,${chevronRight}`,
  close: `data:image/svg+xml;utf8,${close}`,
  condition: `data:image/svg+xml;utf8,${condition}`,
  document: `data:image/svg+xml;utf8,${document}`,
  'dots-three-horizontal': `data:image/svg+xml;utf8,${dotsThreeHorizontal}`,
  edit: `data:image/svg+xml;utf8,${edit}`,
  exclamation: `data:image/svg+xml;utf8,${exclamation}`,
  'eye-off': `data:image/svg+xml;utf8,${eyeOff}`,
  eye: `data:image/svg+xml;utf8,${eye}`,
  faq: `data:image/svg+xml;utf8,${faq}`,
  'file-text': `data:image/svg+xml;utf8,${fileText}`,
  filter: `data:image/svg+xml;utf8,${filter}`,
  helpful: `data:image/svg+xml;utf8,${helpful}`,
  info: `data:image/svg+xml;utf8,${info}`,
  insurance: `data:image/svg+xml;utf8,${insurance}`,
  language: `data:image/svg+xml;utf8,${language}`,
  location: `data:image/svg+xml;utf8,${location}`,
  logout: `data:image/svg+xml;utf8,${logout}`,
  mail: `data:image/svg+xml;utf8,${mail}`,
  'medical-building': `data:image/svg+xml;utf8,${medicalBuilding}`,
  'medical-outline': `data:image/svg+xml;utf8,${medicalOutline}`,
  medical: `data:image/svg+xml;utf8,${medical}`,
  medication: `data:image/svg+xml;utf8,${medication}`,
  nav_benefits: `data:image/svg+xml;utf8,${navBenefits}`,
  nav_more: `data:image/svg+xml;utf8,${navMore}`,
  pause: `data:image/svg+xml;utf8,${pause}`,
  phone: `data:image/svg+xml;utf8,${phone}`,
  play: `data:image/svg+xml;utf8,${play}`,
  plus: `data:image/svg+xml;utf8,${plus}`,
  preferences: `data:image/svg+xml;utf8,${preferences}`,
  privacy: `data:image/svg+xml;utf8,${privacy}`,
  provider: `data:image/svg+xml;utf8,${provider}`,
  refresh: `data:image/svg+xml;utf8,${refresh}`,
  'reorder-two': `data:image/svg+xml;utf8,${reorderTwo}`,
  search: `data:image/svg+xml;utf8,${search}`,
  share: `data:image/svg+xml;utf8,${share}`,
  'thumbs-down': `data:image/svg+xml;utf8,${thumbsDown}`,
  'thumbs-up': `data:image/svg+xml;utf8,${thumbsUp}`,
  time: `data:image/svg+xml;utf8,${time}`,
  trash: `data:image/svg+xml;utf8,${trash}`,
  'user-add': `data:image/svg+xml;utf8,${userAdd}`,
  vitals: `data:image/svg+xml;utf8,${vitals}`,
  x: `data:image/svg+xml;utf8,${x}`,
};
export const ICONS = [
  'allergy',
  'apple',
  'arrow-forward',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'back',
  'book-open',
  'calendar',
  'chat',
  'check-circle',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'close',
  'condition',
  'document',
  'dots-three-horizontal',
  'edit',
  'exclamation',
  'eye-off',
  'eye',
  'faq',
  'file-text',
  'filter',
  'helpful',
  'info',
  'insurance',
  'language',
  'location',
  'logout',
  'mail',
  'medical-building',
  'medical-outline',
  'medical',
  'medication',
  'nav_benefits',
  'nav_more',
  'pause',
  'phone',
  'play',
  'plus',
  'preferences',
  'privacy',
  'provider',
  'refresh',
  'reorder-two',
  'search',
  'share',
  'thumbs-down',
  'thumbs-up',
  'time',
  'trash',
  'user-add',
  'vitals',
  'x',
];
